module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-bottom-stone-path-background.1deecee1.png";